<template src="./template.html"></template>

<script>
import { mapState } from 'vuex'
import TENKENGYOUMU_BASE from 'src/consts/tenkengyoumu_base'
import TENKENGYOUMU_DETAIL from 'src/consts/tenkengyoumu_detail'
import notificationMixin from 'src/mixins/notificationMixin'
import masterMixin from 'src/mixins/masterMixin'
import dobokuSuuryouApi from 'src/apis/masters/doboku_suuryou'

const api = dobokuSuuryouApi
const displayPageName = '土木関係数量'
const msgVars = { create: '作成', update: '編集' }

export default {
  displayPageName: displayPageName,
  data() {
    return {
      displayPageName: displayPageName,

      isReady: false,
      isRequesting: false,

      search: {
        showAll: true,
        tenkenkubunId: null,
      },
      origList: [],
      list: [],
      origTenkenKubunCands: [],
      origHasonjoukyouCands: [],
      hasonjoukyouMap: {},
      saveCandidate: {},
      showSaveModal: false,
      showPasswordModal: false,

      pagination: {
        currentPage: 1,
        itemsPerPage: 50,
      },
    }
  },
  computed: {
    ...mapState('user', {
      has_role_admin: state => state.has_role_admin,
    }),
    hasList() {
      return this.list.length > 0
    },
    paginatedList() {
      const nextPageIdx = this.pagination.currentPage * this.pagination.itemsPerPage
      const minIdx = nextPageIdx - this.pagination.itemsPerPage
      return this.list.filter((e, i) => {
        return i >= minIdx && i < nextPageIdx
      })
    },
    tenkenKubunCands() {
      if (this.search.showAll) { return this.origTenkenKubunCands }
      return this.origTenkenKubunCands.filter(e => {
        const today = new Date()
        const startDt = new Date(e.start_date)
        const endDt = new Date(new Date(e.end_date).valueOf() + 86400 * 1000)
        return (startDt <= today) && (today < endDt)
      })
    },
    hasonjoukyouCands() {
      return this.origHasonjoukyouCands.filter(e => {
        return e.tenkenkubun_id === this.search.tenkenkubunId
      })
    },
  },
  async mounted() {
    await this.ensureUserAndMasters()
    if (!this.has_role_admin) {
      location.href = '/'
    }

    this.prepareMasters()
    this.prepareSearchParams()
    await this.getList()
    this.isReady = true
  },
  mixins: [notificationMixin, masterMixin],
  methods: {
    filterByGyoumu(items) {
      return items.filter(e => {
        return (parseInt(e.tenkengyoumu_base_id) === TENKENGYOUMU_BASE.ROJOU) &&
          (parseInt(e.tenkengyoumu_detail_id) === TENKENGYOUMU_DETAIL.DOBOKU)
      })
    },
    prepareMasters() {
      const master = window.master
      this.origTenkenKubunCands = this.filterByGyoumu(master.tenken_kubun.vals)
      this.origHasonjoukyouCands = this.filterByGyoumu(master.hasonjoukyou.vals)
      this.hasonjoukyouMap = master.hasonjoukyou.vals.reduce((acc, e) => {
        acc[e.uniq_id] = e; return acc
      }, {})
    },
    prepareSearchParams() {
      const search = {
        showAll: true,
        tenkenkubunId: null,
      }
      if (this.origTenkenKubunCands.length > 0) {
        search.tenkenkubunId = this.origTenkenKubunCands[0].m_tenken_kubun_id
      }
      this.search = search
    },
    filterListBySearchParams() {
      this.pagination.currentPage = 1
      this.list = this.origList.filter(e => e.tenkenkubun_id === this.search.tenkenkubunId)
    },
    async getList() {
      this.isRequesting = true
      try {
        const { data } = await dobokuSuuryouApi.index()
        this.origList = this.filterByGyoumu(data)
        this.filterListBySearchParams()
        this.isRequesting = false
      } catch (err) {
        console.error('error', err)
        this.isRequesting = false
      }
    },
    onShowAllChange() {
      let tenkenKubun = this.tenkenKubunCands.find(e => {
        return e.m_tenken_kubun_id === this.search.tenkenkubunId
      })
      if (!tenkenKubun) {
        tenkenKubun = this.tenkenKubunCands[0]
        this.search.tenkenkubunId =
          tenkenKubun ? tenkenKubun.m_tenken_kubun_id : null
      }
    },
    openSaveModal(item) {
      let saveCandidate = {}
      if (!item) {
        saveCandidate.isNew = true
        saveCandidate.tenkengyoumu_base_id = TENKENGYOUMU_BASE.ROJOU
        saveCandidate.tenkengyoumu_detail_id = TENKENGYOUMU_DETAIL.DOBOKU
        saveCandidate.tenkenkubun_id = this.search.tenkenkubunId
      } else {
        saveCandidate = JSON.parse(JSON.stringify(item))
      }
      this.saveCandidate = saveCandidate
      this.showSaveModal = true
    },
    closeSaveModal() {
      this.saveCandidate = {}
      this.showSaveModal = false
    },
    async saveItem() {
      const isValid = await this.$refs.saveCandidate.validate()
      if (!isValid) { return }
      const opType = this.saveCandidate.isNew ? 'create' : 'update'
      try {
        const reqObj = {
          id: this.saveCandidate.id,
          data: this.saveCandidate,
        }
        await api[opType](reqObj)
        await this.getList()
        this.closeSaveModal()
        this.notifySuccess1(`${displayPageName}を${msgVars[opType]}しました`)
      } catch (err) {
        const msg = `${displayPageName}の${msgVars[opType]}に失敗しました。` +
          '管理者に連絡してください。'
        this.notifyError1(msg, { err })
      }
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
